import { useLayoutEffect, useRef } from 'react';

// Open at the latest conversation event, not at the settings below it. Keep
// following late-loading content until the reader takes control of the panel.
export default function useJobConversationScroll(selectionKey, ready) {
  const scrollRef = useRef(null);
  const conversationRef = useRef(null);
  const latestRef = useRef(null);
  const openedSelection = useRef(null);

  useLayoutEffect(() => {
    const scroll = scrollRef.current;
    const conversation = conversationRef.current;
    const latest = latestRef.current;
    if (!ready || !scroll || !conversation || !latest || openedSelection.current === selectionKey) return;
    openedSelection.current = selectionKey;
    let following = true;
    let frame;
    const alignLatest = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        if (!following) return;
        const visibleBottom = scroll.getBoundingClientRect().top + scroll.clientTop + scroll.clientHeight;
        scroll.scrollTop = Math.max(0, scroll.scrollTop + latest.getBoundingClientRect().bottom - visibleBottom + 12);
      });
    };
    const observer = new ResizeObserver(alignLatest);
    const stopFollowing = () => {
      following = false;
      cancelAnimationFrame(frame);
      observer.disconnect();
    };
    observer.observe(conversation);
    const events = ['wheel', 'touchmove', 'pointerdown', 'keydown'];
    events.forEach(event => scroll.addEventListener(event, stopFollowing, { passive: true }));
    alignLatest();
    return () => {
      stopFollowing();
      events.forEach(event => scroll.removeEventListener(event, stopFollowing));
    };
  }, [selectionKey, ready]);

  return { scrollRef, conversationRef, latestRef };
}
